import { HttpError, isError } from "../../state/helpers/Error"
import HttpClient from "../../state/helpers/HttpClient"
import { INTEGRATION_KEY } from "../../state/integration/Constants"
import { SESSION_TYPE } from "../../utils"
import Session, { SessionDto } from "../model/session"

class SessionService {

    static httpClient: HttpClient<Session, SessionDto> =
        new HttpClient<Session, SessionDto>(Session)

    static cacheSession = (sessionType: string, merchantId: string, session: Session, expirationMinutes: number) => {
        const expirationTimestamp = new Date().getTime() + expirationMinutes * 60 * 1000
        const item = {
            session: session,
            expiresAt: expirationTimestamp,
        }
        const sessionKey = `${sessionType}_${merchantId}`
        localStorage.setItem(sessionKey, JSON.stringify(item))
    }

    static getCachedSession = (sessionType: string, merchantId : string) => {
        const sessionKey = `${sessionType}_${merchantId}`
        const item = localStorage.getItem(sessionKey)

        if (!item) {
            return null // Item doesn't exist
        }
        const parsedItem = JSON.parse(item)
        if (parsedItem.expiresAt && parsedItem.expiresAt < new Date().getTime()) {
            localStorage.removeItem(sessionType)
            return null // Item has expired
        }
        return new Session(parsedItem.session.dto)
    }


    static async getSession(sessionType: string, merchantId: string, isProposal?: boolean) {
        let createSession = () => this.createSession(sessionType, merchantId)
        if (isProposal) {
            createSession = () => this.createPayinSession(INTEGRATION_KEY.RAINFOREST, merchantId)
        }

        const session = this.getCachedSession(sessionType, merchantId) ?? await createSession()
        return session as Session
    }

    static async createSession(sessionType: string, merchantId: string): Promise<Session | HttpError> {

        const res = await this.httpClient.post(`/rainforest/sessions/${sessionType}`, {
            merchantID: merchantId
        })
        if (isError(res)) {
            return res as HttpError
        }
        this.cacheSession(sessionType, merchantId, res, 1)
        return res as Session
    }

    static async createPayinSession(integrationKey: INTEGRATION_KEY, merchantId: string): Promise<Session | HttpError> {

        const res = await this.httpClient.post(`/${integrationKey}/payin-sessions`, {
            merchantID: merchantId
        })
        if (isError(res)) {
            return res as HttpError
        }
        this.cacheSession(SESSION_TYPE.CREATE_PAYIN, merchantId, res, 1)
        return res as Session
    }

}

export default SessionService



// WEBPACK FOOTER //
// ./src/payment-account/service/sessionService.ts